import { useContext } from 'react';
import { get } from 'lodash/fp';

import { BreadcrumbContext } from 'breadcrumbs/providers/BreadcrumbProvider';

export const useBreadcrumbs = (root: string) => {
  const breadcrumbs = useContext(BreadcrumbContext);

  return get(root)(breadcrumbs);
};
